import { t } from "i18next";

export const Transl = (key, object) => {
  return t(key, object);
};
